import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Projects from "./components/Projects";

/* ✅ 1) Scroll to top when route changes (NO layout/padding changes) */
function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

/* ✅ 2) Floating scroll-to-top button (fixed, no side spacing issues) */
function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 250);

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      style={{
        position: "fixed",
        right: "clamp(12px, 2.5vw, 22px)",
        bottom: "clamp(12px, 2.5vw, 22px)",
        zIndex: 9999,

        width: "clamp(42px, 4vw, 50px)",
        height: "clamp(42px, 4vw, 50px)",

        borderRadius: "999px",
        border: "none",
        cursor: "pointer",

        display: visible ? "grid" : "none",
        placeItems: "center",

        background: "#111",
        color: "#fff",
        boxShadow: "0 14px 40px rgba(0,0,0,0.25)",
      }}
    >
      ↑
    </button>
  );
}

function AppRoutes() {
  return (
    <>
      <ScrollToTopOnRouteChange />

      <Navbar />

      {/* ✅ IMPORTANT: No padding added here (fixes side spaces) */}
      <main className="appShell" style={{ minHeight: "calc(100vh - 120px)" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />

          {/* ✅ NEW: Projects Page */}
          <Route path="/projects" element={<Projects />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <Footer />

      {/* ✅ global button */}
      <ScrollToTopButton />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
